import React, { useState } from "react";
import { useOrder } from "../context/OrderContext";
import { useOrderSave } from "../context/OrderSaveContext";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import FloatingLabelInput from "../components/form_elements/FloatingLabelInput";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { showErrorToast, showSuccessToast } from "../components/toasts/ToastService";

const emelesLabels = [
    { key: "inraiscorner", label: "Belső emelés sarok", left: "hmeliorder_inraiscorner_left", right: "hmeliorder_inraiscorner_right" },
    { key: "outraiscorner", label: "Külső emelés sarok", left: "hmeliorder_outraiscorner_left", right: "hmeliorder_outraiscorner_right" },
    { key: "inraisbutyok", label: "Belső emelés bütyök", left: "hmeliorder_inraisbutyok_left", right: "hmeliorder_inraisbutyok_right" },
    { key: "outraisbutyok", label: "Külső emelés bütyök", left: "hmeliorder_outraisbutyok_left", right: "hmeliorder_outraisbutyok_right" },
    { key: "inraisnose", label: "Belső emelés orr", left: "hmeliorder_inraisnose_left", right: "hmeliorder_inraisnose_right" },
    { key: "outraisnose", label: "Külső emelés orr", left: "hmeliorder_outraisnose_left", right: "hmeliorder_outraisnose_right" }
];

const Emeles = () => {
    const { order, updateOrder } = useOrder();
    const { saveOrder } = useOrderSave();
    const navigate = useStepNavigate();

    const [bal, setBal] = useState({
        inraisnose: order.hmeliorder?.hmeliorder_inraisnose_left || "",
        inraiscorner: order.hmeliorder?.hmeliorder_inraiscorner_left || "",
        inraisbutyok: order.hmeliorder?.hmeliorder_inraisbutyok_left || "",
        outraisnose: order.hmeliorder?.hmeliorder_outraisnose_left || "",
        outraiscorner: order.hmeliorder?.hmeliorder_outraiscorner_left || "",
        outraisbutyok: order.hmeliorder?.hmeliorder_outraisbutyok_left || ""
    });
    const [jobb, setJobb] = useState({
        inraisnose: order.hmeliorder?.hmeliorder_inraisnose_right || "",
        inraiscorner: order.hmeliorder?.hmeliorder_inraiscorner_right || "",
        inraisbutyok: order.hmeliorder?.hmeliorder_inraisbutyok_right || "",
        outraisnose: order.hmeliorder?.hmeliorder_outraisnose_right || "",
        outraiscorner: order.hmeliorder?.hmeliorder_outraiscorner_right || "",
        outraisbutyok: order.hmeliorder?.hmeliorder_outraisbutyok_right || ""
    });

    const [loading, setLoading] = useState(false);

    const onefoot = order.hmeliorder?.hmeliorder_is_onefoot_meas;
    const isLeft = order.hmeliorder?.hmeliorder_is_left;

    const showBal = onefoot === 0 || (onefoot === 1 && isLeft === 1);
    const showJobb = onefoot === 0 || (onefoot === 1 && isLeft === 0);

    const handleInput = (side, key, value) => {
        if (/^\d{0,2}(\.\d{0,2})?$/.test(value)) {
            if (side === "bal") {
                const uj = { ...bal, [key]: value };
                setBal(uj);
                updateOrder({
                    ...order,
                    hmeliorder: {
                        ...order.hmeliorder,
                        hmeliorder_inraisnose_left: uj.inraisnose,
                        hmeliorder_inraiscorner_left: uj.inraiscorner,
                        hmeliorder_inraisbutyok_left: uj.inraisbutyok,
                        hmeliorder_outraisnose_left: uj.outraisnose,
                        hmeliorder_outraiscorner_left: uj.outraiscorner,
                        hmeliorder_outraisbutyok_left: uj.outraisbutyok
                    }
                });
            } else {
                const uj = { ...jobb, [key]: value };
                setJobb(uj);
                updateOrder({
                    ...order,
                    hmeliorder: {
                        ...order.hmeliorder,
                        hmeliorder_inraisnose_right: uj.inraisnose,
                        hmeliorder_inraiscorner_right: uj.inraiscorner,
                        hmeliorder_inraisbutyok_right: uj.inraisbutyok,
                        hmeliorder_outraisnose_right: uj.outraisnose,
                        hmeliorder_outraiscorner_right: uj.outraiscorner,
                        hmeliorder_outraisbutyok_right: uj.outraisbutyok
                    }
                });
            }
        }
    };

    const handleSaveAndNavigate = async () => {
        try {
            setLoading(true);

            const updatedOrder = {
                ...order,
                hmeliorder: {
                    ...order.hmeliorder,
                    hmeliorder_inraisnose_left: bal.inraisnose,
                    hmeliorder_inraiscorner_left: bal.inraiscorner,
                    hmeliorder_inraisbutyok_left: bal.inraisbutyok,
                    hmeliorder_outraisnose_left: bal.outraisnose,
                    hmeliorder_outraiscorner_left: bal.outraiscorner,
                    hmeliorder_outraisbutyok_left: bal.outraisbutyok,
                    hmeliorder_inraisnose_right: jobb.inraisnose,
                    hmeliorder_inraiscorner_right: jobb.inraiscorner,
                    hmeliorder_inraisbutyok_right: jobb.inraisbutyok,
                    hmeliorder_outraisnose_right: jobb.outraisnose,
                    hmeliorder_outraiscorner_right: jobb.outraiscorner,
                    hmeliorder_outraisbutyok_right: jobb.outraisbutyok
                }
            };

            updateOrder(updatedOrder);

            const result = await saveOrder(updatedOrder);
            if (result.success) {
                showSuccessToast("A rendelés sikeresen mentve!");
                navigate("/FelolvasoTabla");
            } else {
                showErrorToast("Hiba történt a rendelés mentésekor!");
            }
        } catch (error) {
            console.error("Hiba a rendelés mentésekor:", error);
            showErrorToast("Hiba történt a rendelés mentésekor!");
        } finally {
            setLoading(false);
        }
    };

    const handleBackClick = () => {
            navigate("/Meretvetel");
    };


    return (
        <TablerLayout title="Emelés megadása">
            <div className="row justify-content-center">
                <div className="col-md-10">
                    <div className="card-body">
                        <div className="row g-4">
                            <div className="row">
                            <div className="col-12 col-md-6 mb-4 mb-md-0">
                                <div className="text-center fw-bold fs-5 mb-3">Bal láb</div>
                                {emelesLabels.map((l, idx) => (
                                    <div className="mb-3" key={l.key}>
                                        <FloatingLabelInput
                                            label={l.label}
                                            id={`bal-${l.key}`}
                                            name={`bal-${l.key}`}
                                            type="number"
                                            step="0.01"
                                            min="0"
                                            max="99"
                                            addon="mm"
                                            fontSize={25}
                                            value={bal[l.key]}
                                            onChange={(e) => handleInput("bal", l.key, e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter" || e.key === "Return") {
                                                    e.preventDefault();
                                                    const nextIdx = idx + 1;
                                                    if (nextIdx < emelesLabels.length) {
                                                        const nextInput = document.getElementById(`bal-${emelesLabels[nextIdx].key}`);
                                                        if (nextInput) {
                                                            nextInput.focus();
                                                            return;
                                                        }
                                                    }
                                                    if (showJobb) {
                                                        const nextInput = document.getElementById(`jobb-${emelesLabels[0].key}`);
                                                        if (nextInput) {
                                                            nextInput.focus();
                                                            return;
                                                        }
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                ))}
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="text-center fw-bold fs-5 mb-3">Jobb láb</div>
                                {emelesLabels.map((l, idx) => (
                                    <div className="mb-3" key={l.key}>
                                        <FloatingLabelInput
                                            label={l.label}
                                            id={`jobb-${l.key}`}
                                            name={`jobb-${l.key}`}
                                            type="number"
                                            step="0.01"
                                            min="0"
                                            max="99"
                                            addon="mm"
                                            fontSize={25}
                                            value={jobb[l.key]}
                                            onChange={(e) => handleInput("jobb", l.key, e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter" || e.key === "Return") {
                                                    e.preventDefault();
                                                    const nextIdx = idx + 1;
                                                    if (nextIdx < emelesLabels.length) {
                                                        const nextInput = document.getElementById(`jobb-${emelesLabels[nextIdx].key}`);
                                                        if (nextInput) {
                                                            nextInput.focus();
                                                            return;
                                                        }
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                    <div className="card-footer d-flex justify-content-between">
                        <StepperNavButton
                            side="left"
                            label="Vissza"
                            onClick={handleBackClick}
                        />
                        <StepperNavButton
                            side="right"
                            label="Tovább"
                            onClick={() => handleSaveAndNavigate('/FelolvasoTabla')}
                            disabled={loading}
                        />
                    </div>
                </div>
            </div>
        </TablerLayout>
    );
};

export default Emeles;